<template>
    <button type="submit" class="btn btn-loader" :disabled="disabled" :class="{'btn-loading': sending}">
        <svg-loader />
        <span>{{ label }}</span>
    </button>
</template>

<script>
import SvgLoader from '@/assets/images/loader.svg'

// @see https://nzbin.github.io/three-dots/
export default {
    components: { SvgLoader },
    props: {
        disabled: Boolean,
        sending: Boolean,
        label: String
    }
}
</script>
